import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconAngleUp: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 10.5002C12.5387 10.5002 12.4107 10.4515 12.3134 10.3535L8.00006 6.04022L3.68674 10.3535C3.49141 10.5489 3.17472 10.5489 2.97939 10.3535C2.78405 10.1582 2.78405 9.84151 2.97939 9.64617L7.64605 4.97951C7.84139 4.78417 8.15808 4.78417 8.35341 4.97951L13.0201 9.64617C13.2154 9.84151 13.2154 10.1582 13.0201 10.3535C12.9227 10.4515 12.7947 10.5002 12.6667 10.5002Z"
      fill={color}
    />
  </svg>
);

export default IconAngleUp;
